module.exports = __webpack_public_path__ + "img/tools-phone.2bfec0e5.png";